import request from '@/api/request'

// findByTokenNew
export function findByTokenNew(data) {
	return request({
		url: '/api/polyv/findByToken',
		method: 'get',
		params: data,
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

// banner
export function getBanner(majorId) {
	return request({
		url: '/api/operate/banner/wdOperateBanner/pcList',
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

//专业列表
export function getMajorList() {
	return request({
		url: '/api/resources/major/wdResourcesMajor/list',
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

//直播预告
export function getAuditionLivePageList(majorId) {
	return request({
		url: 'api/courseapi/findByLivePreview?majorId=' + majorId,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}


//试听直播
export function getCourseapiList(majorId) {
	return request({
		url: 'api/courseapi/auditionLivePageList?majorId=' + majorId.majorId + '&pageNo=' + majorId.pageNo +
			'&pageSize=' + majorId.pageSize,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

//试听课程
export function getAuditionCoursePageList(majorId) {
	console.log(majorId)
	return request({
		url: '/api/courseapi/auditionCoursePageList?majorId=' + majorId.majorId + '&pageNo=' + majorId.pageNo +
			'&pageSize=' + majorId.pageSize,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}


//获取保利威视 视频ToKen
export function getPolyvFindByToken(data) {
	return request({
		url: `/api/polyv/findByToken?courseId=${data.courseId}&classesId=${data.classesId}`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

//系列课程
export function getSeriesCoursePageList(majorId, pageInfo) {
	return request({
		url: `/api/courseapi/seriesCoursePageList?majorId=${majorId}&pageSize=${pageInfo.pageSize}&pageNo=${pageInfo.pageNo}`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}
//系列课程
export function queryCoursePageList(majorId, pageInfo) {
	return request({
		url: `/api/courseapi/queryCoursePageList?majorId=${majorId}&pageSize=${pageInfo.pageSize}&pageNo=${pageInfo.pageNo}`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

//面授课程
export function getFaceCoursePageList(majorId, pageInfo) {
	return request({
		url: `/api/courseapi/faceCoursePageList?majorId=${majorId}&pageSize=${pageInfo.pageSize}&pageNo=${pageInfo.pageNo}`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}


//学员评价
export function getStudentCommentList() {
	return request({
		url: '/api/studentcomment/wdStudentComment/list?pageSize=20',
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

//资讯
export function getInformationList() {
	return request({
		url: '/api/information/wdInformation/list?pageSize=15',
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

//资讯分类
export function getInformationClassifyList() {
	return request({
		url: '/api/informationClassify/wdInformationClassify/list?pageSize=6',
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

//讲师
export function getTeacherList(data) {
	return request({
		url: `/api/resources/wdResourcesTeacher/wdResourcesTeacher/list?pageSize=${data.pageSize}&majorId=${data.majorId}`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

//获取直播间地址
export function getLiveUrl(data) {
	return request({
		url: `/api/courseapi/getLiveUrl?channelId=${data.channelId}&userid=${data.userid}`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

//获取视频token
export function getPolyvToken(data) {
	if (data.classesId == undefined) {
		return request({
			url: `/api/polyv/findByToken?courseId=${data.courseId}`,
			method: 'get',
			headers: {
				"Content-Type": "application/json",
				"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') :
					''
			},
		})
	} else {
		return request({
			url: `/api/polyv/findByToken?courseId=${data.courseId}&classesId=${data.classesId}`,
			method: 'get',
			headers: {
				"Content-Type": "application/json",
				"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') :
					''
			},
		})
	}

}

//我的购物车
export function getMyCart() {
	return request({
		url: `/api/shopping/cart/list`,
		method: 'post',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

// 清理购物车
export function deleteShopCart(bookIds) {
	return request({
		url: '/api/shopping/cart/deleteBatch?bookIds=' + bookIds,
		method: 'delete',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}


// WEBPACK FOOTER //
// ./src/api/home.js